import { render } from "./AdminMenu.vue?vue&type=template&id=8f5f02de&scoped=true"
import script from "./AdminMenu.vue?vue&type=script&lang=ts"
export * from "./AdminMenu.vue?vue&type=script&lang=ts"

import "./AdminMenu.vue?vue&type=style&index=0&id=8f5f02de&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-8f5f02de"

export default script